import { useCallback, useEffect, useRef } from "react";

import ModalHeader from "./ModalHeader";
import ModalBody from "./ModalBody";
import ModalFooter from "./ModalFooter";
import useSwipe from "./hooks/useSwipe";

export default function GalleryModal({ gallery }) {
    const modalRef = useRef(null);

    const swipe = useSwipe({
        onNext: gallery.next,
        onPrevious: gallery.previous,
    });

    const handleKeyDown = useCallback(
        (e) => {
            switch (e.key) {
                case "ArrowLeft":
                    gallery.next();
                    break;

                case "ArrowRight":
                     gallery.previous();
                   
                    break;

                case "Escape":
                    gallery.closeModal();
                    break;

                default:
                    break;
            }
        },
        [gallery]
    );

    useEffect(() => {
        if (!gallery.isOpen) return;

        const previousOverflow = document.body.style.overflow;

        document.body.style.overflow = "hidden";

        modalRef.current?.focus();

        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, [gallery.isOpen]);

    if (!gallery.isOpen) return null;

    return (
        <div
            className="gallery-overlay"
            onClick={gallery.closeModal}
            onTouchStart={swipe.onTouchStart}
            onTouchEnd={swipe.onTouchEnd}
        >
            <div
                ref={modalRef}
                className="gallery-modal"
                role="dialog"
                aria-modal="true"
                tabIndex={0}
                onClick={(e) => e.stopPropagation()}
                onKeyDown={handleKeyDown}
            >
                <ModalHeader gallery={gallery} />

                <ModalBody gallery={gallery} />

                <ModalFooter gallery={gallery} />
            </div>
        </div>
    );
}